import { Component, Inject } from '@angular/core';
import { IonNav, IonicModule } from '@ionic/angular';

import { AuthUIServiceInterface, AUTH_UI_SERVICE } from 'src/app/services/auth/auth-ui.service.interface';
import { BaseAuthPage } from '../auth-common/base-auth-page';
import { ActionSource } from '../../../services/yeti-protocol/tracking';
import { CommonModule } from '@angular/common';
import { AuthWelcomeSmallScreenComponent }
  from 'src/app/modules/auth-components/auth-welcome-small-screen/auth-welcome-small-screen.component';

@Component({
  selector: 'app-auth-start-signup',
  templateUrl: './auth-welcome.page.html',
  styleUrls: ['./auth-welcome.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    AuthWelcomeSmallScreenComponent
  ]
})
export class AuthWelcomePage extends BaseAuthPage {

  ActionSource = ActionSource;
  constructor(
    nav: IonNav,
    @Inject(AUTH_UI_SERVICE) authUIService: AuthUIServiceInterface
  ) {
    super(nav, authUIService);
  }
}
